import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const offPlanProjects = [
  {
    id: 'OP-2024-001',
    name: 'Creek Harbour Residences',
    developer: 'Emaar Properties',
    masterDeveloper: 'Dubai Creek Harbour',
    masterApproval: 'MA-2022-4521',
    constructionPermit: 'CP-2024-78934',
    salesAuth: 'SA-2024-00123',
    type: 'Residential Tower',
    units: 450,
    soldUnits: 312,
    priceRange: 'AED 1.2M – 4.8M',
    paymentPlan: '20/80',
    handover: 'Q4 2026',
    progress: 35,
    allApproved: true
  },
  {
    id: 'OP-2024-002',
    name: 'Business Bay Heights',
    developer: 'DAMAC Properties',
    masterDeveloper: 'Dubai Properties',
    masterApproval: 'MA-2023-3312',
    constructionPermit: 'CP-2024-56721',
    salesAuth: 'SA-2024-00456',
    type: 'Mixed Use',
    units: 280,
    soldUnits: 198,
    priceRange: 'AED 900K – 3.2M',
    paymentPlan: '10/90',
    handover: 'Q2 2027',
    progress: 18,
    allApproved: true
  },
  {
    id: 'OP-2024-003',
    name: 'JVC Garden Villas',
    developer: 'Nakheel',
    masterDeveloper: 'Nakheel',
    masterApproval: 'MA-2021-7890',
    constructionPermit: 'Pending',
    salesAuth: 'SA-2024-00789',
    type: 'Villa Community',
    units: 120,
    soldUnits: 45,
    priceRange: 'AED 2.1M – 5.5M',
    paymentPlan: '50/50',
    handover: 'Q1 2028',
    progress: 8,
    allApproved: false
  }
];

const OffPlanCompliance = () => {
  const [selected, setSelected] = useState(null);

  return (
    <div className="rounded-2xl p-6" style={{ background: 'rgba(10,22,40,0.9)', border: '1px solid rgba(0,212,255,0.2)' }}>
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: 'rgba(0,212,255,0.1)', border: '1px solid rgba(0,212,255,0.3)' }}>
          <Icon name="FileCheck" size={20} color="#00D4FF" />
        </div>
        <div>
          <h3 className="text-lg font-bold" style={{ color: '#E8F4FF' }}>Off-Plan Compliance Checker</h3>
          <p className="text-xs" style={{ color: '#6B9EC4' }}>Master developer approvals, construction permits & sales authorization</p>
        </div>
      </div>
      <div className="space-y-3">
        {offPlanProjects?.map((proj, i) => (
          <div key={i}>
            <button
              onClick={() => setSelected(selected?.id === proj?.id ? null : proj)}
              className="w-full text-left p-4 rounded-xl transition-all"
              style={{ background: selected?.id === proj?.id ? 'rgba(0,212,255,0.1)' : 'rgba(0,212,255,0.04)', border: `1px solid ${selected?.id === proj?.id ? 'rgba(0,212,255,0.4)' : 'rgba(0,212,255,0.12)'}` }}
            >
              <div className="flex items-start justify-between gap-2">
                <div>
                  <div className="font-semibold text-sm mb-1" style={{ color: '#E8F4FF' }}>{proj?.name}</div>
                  <div className="text-xs" style={{ color: '#6B9EC4' }}>{proj?.developer} · {proj?.type} · {proj?.units} units</div>
                </div>
                <span className="text-xs px-2 py-1 rounded-full flex-shrink-0" style={proj?.allApproved ? { background: 'rgba(34,197,94,0.1)', color: '#22c55e' } : { background: 'rgba(245,158,11,0.1)', color: '#f59e0b' }}>
                  {proj?.allApproved ? '✓ All Approved' : '⚠ Pending'}
                </span>
              </div>
              <div className="mt-2">
                <div className="flex justify-between text-xs mb-1" style={{ color: '#6B9EC4' }}>
                  <span>Construction Progress</span>
                  <span style={{ color: '#00D4FF' }}>{proj?.progress}%</span>
                </div>
                <div className="h-1.5 rounded-full" style={{ background: 'rgba(255,255,255,0.1)' }}>
                  <div className="h-1.5 rounded-full" style={{ width: `${proj?.progress}%`, background: '#00D4FF' }} />
                </div>
              </div>
            </button>

            {selected?.id === proj?.id && (
              <div className="mt-2 p-4 rounded-xl" style={{ background: 'rgba(0,212,255,0.05)', border: '1px solid rgba(0,212,255,0.15)' }}>
                <div className="grid grid-cols-2 gap-3 mb-4">
                  {[
                    { label: 'Master Developer', value: proj?.masterDeveloper },
                    { label: 'Master Approval', value: proj?.masterApproval },
                    { label: 'Construction Permit', value: proj?.constructionPermit },
                    { label: 'Sales Authorization', value: proj?.salesAuth },
                    { label: 'Price Range', value: proj?.priceRange },
                    { label: 'Payment Plan', value: proj?.paymentPlan },
                    { label: 'Handover', value: proj?.handover },
                    { label: 'Units Sold', value: `${proj?.soldUnits} / ${proj?.units}` }
                  ]?.map((item, j) => (
                    <div key={j} className="p-2 rounded-lg" style={{ background: 'rgba(10,22,40,0.6)' }}>
                      <div className="text-xs" style={{ color: '#6B9EC4' }}>{item?.label}</div>
                      <div className="text-sm font-medium" style={{ color: item?.value === 'Pending' ? '#f59e0b' : '#E8F4FF' }}>{item?.value}</div>
                    </div>
                  ))}
                </div>
                <div className="flex gap-2">
                  <button className="flex-1 py-2 rounded-lg text-xs font-medium" style={{ background: 'rgba(0,212,255,0.1)', border: '1px solid rgba(0,212,255,0.3)', color: '#00D4FF' }}>
                    View DLD Documents
                  </button>
                  <button className="flex-1 py-2 rounded-lg text-xs font-medium" style={{ background: 'rgba(0,212,255,0.1)', border: '1px solid rgba(0,212,255,0.3)', color: '#00D4FF' }}>
                    Download Permit
                  </button>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default OffPlanCompliance;
